export default "__VITE_ASSET__CKedGXzC__"